module.exports = __webpack_public_path__ + "d24579aade7357789e0c52b6dd581b13.svg";